window.addEventListener("load", function () {
	const btnTop = document.querySelector("#libraryMainsite-t-float_right .btn-top");
	const frame1 = document.querySelector("#libraryMainsite-t-float_left .MJ__followFrame");

	if (btnTop && frame1) {
		btnTop.addEventListener("click", function (e) {
			e.preventDefault();
			frame1.click();
		});
	}
});
